<template>
<div class="chapter">
<div class="inner_page">
<p class="textcentera"><a id="ch00_fm02"></a><a id="page_ii"><span class="smallcaps">ALSO BY LAURIE FOX</span></a></p><a id="page_ii">
<p class="textcenter1"><em>My Sister from the Black Lagoon<br/>Sexy Hieroglyphics</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm02.vue?0e6988c0